import { Injectable } from '@angular/core';
@Injectable()
export class FeatureFlags {
    redirect_to_pca: boolean;
    click_to_chat_enabled: boolean;
    click_to_chat_search: boolean;
    click_to_chat_results: boolean;
    click_to_chat_confirmation: boolean;
  }
